module.exports = __webpack_public_path__ + "static/media/logo_2024.a59108ee.png";


//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/src/resources/images/logo_2024.png
// module id = 698
// module chunks = 0